import { render } from "./Subheading.vue?vue&type=template&id=16e8fed1"
import script from "./Subheading.vue?vue&type=script&lang=js"
export * from "./Subheading.vue?vue&type=script&lang=js"

import "./Subheading.vue?vue&type=style&index=0&id=16e8fed1&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__